/* basic. production runtime adapter */
(() => {
  const page = document.querySelector('.catalogue-index');
  if (!page) return;

  const search = page.querySelector('#catalogue-search');
  const cards = [...page.querySelectorAll('.catalogue-card')];
  const universeButtons = [...page.querySelectorAll('[data-catalogue-universe]')];
  const familyButtons = [...page.querySelectorAll('[data-catalogue-family]')];
  const count = page.querySelector('#catalogue-result-count');
  const empty = page.querySelector('#catalogue-empty');
  const reset = page.querySelector('#catalogue-reset');
  let universe = 'all';
  let family = 'all';

  const normalize = value => (value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const parameters = new URLSearchParams(window.location.search);
  const collectionUniverses = {deodorants:'deodorants',visage:'visage',corps:'corps',cheveux:'cheveux','baume-a-levres':'levres',levres:'levres',huiles:'huiles'};
  const collectionHandle = window.BasicShopifyConfig?.collectionHandle || '';
  const requestedUniverse = normalize(parameters.get('categorie') || collectionUniverses[collectionHandle] || '');
  const requestedFamily = normalize(parameters.get('famille'));
  universe = universeButtons.find(button => normalize(button.dataset.catalogueUniverse) === requestedUniverse)?.dataset.catalogueUniverse || 'all';
  family = familyButtons.find(button => normalize(button.dataset.catalogueFamily) === requestedFamily || (requestedFamily === 'sans-famille' && button.dataset.catalogueFamily === 'none'))?.dataset.catalogueFamily || 'all';
  search.value = parameters.get('q') || '';

  function updateUrl() {
    const params = new URLSearchParams(window.location.search);
    if (universe === 'all') params.delete('categorie'); else params.set('categorie', normalize(universe));
    if (family === 'all') params.delete('famille'); else params.set('famille', family === 'none' ? 'sans-famille' : family);
    if (!search.value.trim()) params.delete('q'); else params.set('q', search.value.trim());
    const query = params.toString();
    window.history.replaceState(null, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);
  }

  function updateButtons(buttons, key, selected) {
    buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset[key] === selected)));
  }

  function render() {
    const query = normalize(search.value);
    let visible = 0;
    cards.forEach(card => {
      if (window.BasicCampaignRetirement?.isEnded() && window.BasicCampaignRetirement.campaignUrl(card.href)) {
        card.hidden = true; card.remove(); return;
      }
      const matchesUniverse = universe === 'all' || card.dataset.universe === universe;
      const matchesFamily = family === 'all' || (family === 'none' ? card.dataset.family === '' : card.dataset.family.split(' ').includes(family));
      const matchesSearch = !query || normalize(card.dataset.search).includes(query);
      card.hidden = !(matchesUniverse && matchesFamily && matchesSearch);
      if (!card.hidden) visible += 1;
    });
    count.textContent = `${visible} produit${visible > 1 ? 's' : ''}`;
    empty.hidden = visible !== 0;
  }

  universeButtons.forEach(button => button.addEventListener('click', () => {
    universe = button.dataset.catalogueUniverse;
    updateButtons(universeButtons, 'catalogueUniverse', universe);
    render();
    updateUrl();
  }));
  familyButtons.forEach(button => button.addEventListener('click', () => {
    family = button.dataset.catalogueFamily;
    updateButtons(familyButtons, 'catalogueFamily', family);
    render();
    updateUrl();
  }));
  search.addEventListener('input', () => { render(); updateUrl(); });
  reset.addEventListener('click', () => {
    universe = 'all';
    family = 'all';
    search.value = '';
    updateButtons(universeButtons, 'catalogueUniverse', universe);
    updateButtons(familyButtons, 'catalogueFamily', family);
    render();
    updateUrl();
    search.focus();
  });
  updateButtons(universeButtons, 'catalogueUniverse', universe);
  updateButtons(familyButtons, 'catalogueFamily', family);
  window.addEventListener('basic-campaign-ended', render);
  render();
})();
